module.exports = __webpack_public_path__ + "img/testi-2.894562ec.jpg";